import { render, staticRenderFns } from "./menuIcon.vue?vue&type=template&id=3e34bf06&"
import script from "./menuIcon.vue?vue&type=script&lang=js&"
export * from "./menuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports